// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * Converts a Medplum Binary URL, including a presigned storage URL, into the
 * Binary/{id} form expected by MedplumClient.download.
 */
export function getBinaryDownloadUrl(url: string | undefined): string | undefined {
  if (!url) {
    return undefined;
  }

  const path = url.split(/[?#]/, 1)[0].replace(/\/+$/, '');
  const segments = path.split('/').filter(Boolean);
  const binarySegmentIndex = segments.findIndex((segment) => segment.toLowerCase() === 'binary');
  const binaryId = segments[binarySegmentIndex + 1];
  if (binarySegmentIndex < 0 || !binaryId) {
    return url;
  }

  let decodedBinaryId = binaryId;
  try {
    decodedBinaryId = decodeURIComponent(binaryId);
  } catch {
    // Keep the original path segment if a malformed URL-encoded ID is supplied.
  }
  return `Binary/${decodedBinaryId}`;
}
